import React, { useState } from 'react';
import CpSearchBar from '../../../../components/CpSearchBar';
import { STATIC_RESOURCE } from '../../../../origin';

function Index(props) {
  const { language = 'zh_' } = props;
  const [searchValue, setSearchValue] = useState('');
  const [searchType, setSearchType] = useState('1');
  const searchValueChanged = (value) => {
    setSearchValue(value);
  };
  const searchTypeChanged = (value) => {
    setSearchType(value);
  };
  // searchValue = '', searchType = '1',
  return (
    <div className='search-container'>
      <div className='search-content'>
        <img className='search-container-logo' src={`${STATIC_RESOURCE}/cp_purchase/index/logo.png`} alt='' />
        <div style={{ marginLeft: '40px' }}>
          <CpSearchBar
            language={language}
            searchValue={searchValue}
            searchType={searchType}
            searchValueChanged={searchValueChanged}
            searchTypeChanged={searchTypeChanged} />
        </div>
      </div>
    </div>
  );
}

export default Index;